module.exports = "/images/Maestro.svg?93826edaf79188fd04190936c0f14394";